import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, FirstPersonControls, Reflector, Box } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import GifLoader from "three-gif-loader";
import { Particles, Houses, Skyscraper, Floor } from './ParticleSystems';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { TextureLoader } from 'three/src/loaders/TextureLoader.js';

extend({ EffectComposer, RenderPass, UnrealBloomPass });


function Effect({ intensity }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current?.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[aspect, intensity, 0.5, 0]} />
    </effectComposer>
    </>
  )
}



const params = new URLSearchParams(window.location.search);
const viewer = params.get('viewer');
let viewerIsOwner = false;
let objktPart2 = parseInt(params.get("objkt"), 10);
// let objktPart2 = 508975;
let objkt = 555393;
let clicked = false;

const query = `
query Objkt($id: bigint!) {
  hic_et_nunc_token_by_pk(id: $id) {
    token_holders(where: {holder: {address: {_nregex: "(KT1HbQepzV1nVGg8QVznG7z4RcHseD5kwqBn)|(KT1FvqJwEDWb1Gwc55Jd1jjTHRVWbYKUUpyq)"}}, quantity: {_gt: "0"}}, order_by: {id: asc}) {
      quantity
      holder {
        address
        name
      }
    }
    
    swaps(where: {status: {_eq: "0"}}) {
      creator {
        name
        address
      }
    }
  }
}
`;

const queryArtist = `
query creatorGallery($address: String!) {
  hic_et_nunc_token(where: {creator: {address: {_eq: $address}}, supply: {_gt: 0}}, order_by: {id: desc}) {
    display_uri
  }
}
`;

const queryCollector = `
query collectorGallery($address: String!) {
  hic_et_nunc_token_holder(where: {holder_id: {_eq: $address}, quantity: {_gt: "0"}, token: {supply: {_gt: "0"}}}, order_by: {id: desc}) {
    token {
      display_uri
    }
  }
}
`;



async function fetchGraphQL(operationsDoc, operationName, variables) {
  const result = await fetch(
    "https://api.hicdex.com/v1/graphql",
    {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName
      })
    }
  );

  return await result.json();
}

async function doFetch(id) {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(query, "Objkt", {"id":id});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    const result = data.hic_et_nunc_token_by_pk;
    // console.log({ result });
    return result;
  }
}

async function doFetchArtist(address) {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(queryArtist, "creatorGallery", {"address":address});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    let result = data.hic_et_nunc_token;
    result = result.map((url) => {
      return 'https://cloudflare-ipfs.com/ipfs/' + url.display_uri.slice(7);
    })
    console.log(result)
    return result;
  }
}

async function doFetchCollector(address) {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(queryCollector, "collectorGallery", {"address":address});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    let result = data.hic_et_nunc_token_holder;
    console.log(result)
    result = result.map((url) => {
      return 'https://cloudflare-ipfs.com/ipfs/' + url.token.display_uri.slice(7);
    })
    console.log(result)
    return result;
  }
}

function checkViewerIsOwner(data) {
  if(!data || !data.token_holders) return;
  if (data.token_holders.some((e) => e.holder.address === viewer)) {
    console.log(`viewer IS owner`);
    viewerIsOwner = true;
  } else {
    console.log(`viewer is NOT owner`);
  }
  //console.log({ OBJKT: data });
}

function changeData(data) {
  console.log(data);
  if(!data || !data.token_holders) return;

  let curData = data.token_holders.map((holder) => { 
    return {name:    holder.holder.name ? holder.holder.name : 
                                holder.holder.address.substr(0,4) + "..." + holder.holder.address.substr(-4), 
            address: holder.holder.address};
  });
  let swapData = data.swaps?.map((holder) => { 
    return {name:    holder.creator.name ? holder.creator.name : 
                                holder.creator.address.substr(0,4) + "..." + holder.creator.address.substr(-4), 
            address: holder.creator.address};
  });
  
  console.log(swapData)
  return curData.concat(swapData);
}


let currentArtist = '';
// function RecursiveBox({size, pos, depth}) {
//   amount++;
//   console.log(amount)
//   if(depth > 0) 
//     return (
//     <mesh position={pos}>
//       <boxGeometry args={size} />
//       <meshBasicMaterial color={'hsl(' + Math.random()*345 + ', 100%, 50%)'} />
//     </mesh>
//   );

//   // let lSize = [size[0] * Math.random(), size[1], size[2]];
//   // let rSize = [size[0] - lSize[0], size[1], size[2]];
//   let sizeNew = [size[0] / 2, size[1] / 2, size[2] / 2];

//   let ldPos = [pos[0] - size[0]/4,  pos[1] - size[1] / 4, pos[2]];
//   let luPos = [pos[0] - size[0]/4,  pos[1] + size[1] / 4, pos[2]];
//   let rdPos = [pos[0] + size[0]/4,  pos[1] - size[1] / 4, pos[2]];
//   let ruPos = [pos[0] + size[0]/4,  pos[1] + size[1] / 4, pos[2]];
//   // console.log(lSize, lPos)
//   return <>
//     <RecursiveBox size={sizeNew} pos={ldPos} depth={depth+1}/>
//     <RecursiveBox size={sizeNew} pos={luPos} depth={depth+1}/>
//     <RecursiveBox size={sizeNew} pos={rdPos} depth={depth+1}/>
//     <RecursiveBox size={sizeNew} pos={ruPos} depth={depth+1}/>
//   </>
// }
function getCanvasTexture(children, color) {
  console.log(children)
  const fontSize = 1024;

  const canvas = document.createElement('canvas');
  canvas.width = 2048;
  canvas.height = 2048;
  const context = canvas.getContext('2d');

  context.font = `bold ${fontSize}px -apple-system, helvetica, ubuntu, roboto, arial, sans-serif`;
  context.textAlign = 'center';
  context.textBaseline = 'middle';
  context.fillStyle = color;
  context.fillText(children, 1024, canvas.height / 2, 2000);
  return canvas;
}

function getCanvasImageTexture(uri, index) {
  const canvas = document.createElement('canvas');
  canvas.width=256;
  canvas.height=256;
  const ctx = canvas.getContext("2d");

  const img = new Image();
  img.onload = () => {
    ctx.drawImage(img,0,0,256,256); // Or at whatever offset you like
    // clearInterval(handler);
  };
  // img.
  img.crossOrigin='anonymous';
  // img.loading='lazy';
  img.decoding='async';
  setTimeout(() => img.src = uri, 500 * index);

  
  return canvas;
}

function Preload({uri, index, ...args}) {
  const ref=useRef();
  const {gl, scene} = useThree();
  // gl.toneMapping = THREE.ReinhardToneMapping;
  
  const canvas = useMemo(() => {
    return getCanvasImageTexture(uri, index);
  }, [uri, index]);

  // useEffect(() => {
  //   scene.getObjectByName('tracable2').add(ref.current);
  // });

  const texture = useRef();
  
  
  return (
      <mesh ref={ref} {...args}>
        <planeGeometry args={[3,3]} />
        <meshBasicMaterial attach="material" side={THREE.DoubleSide}>
          <canvasTexture
            attach="map"
            image={canvas}
            ref={texture}
            wrapS={THREE.ClampToEdgeWrapping}
            wrapT={THREE.ClampToEdgeWrapping}
            encoding={THREE.sRGBEncoding}
            onUpdate={(s) => (s.needsUpdate = true)}
          />
        </meshBasicMaterial>
      </mesh>);
}

function Bilboard({person, position}) {
  const ref=useRef();
  const {scene} = useThree();
  
  const canvas = useMemo(() => {
    return getCanvasTexture(person.name, "grey")
  }, [person]);

  useEffect(() => {
    let tracable = scene.getObjectByName('tracableInner');
    if(!tracable.getObjectByName(person.address))
      tracable.add(ref.current);
  });

  const texture = useRef();
  let oldTime = 0;
  
  useFrame(({ clock, raycaster, mouse, camera }) => {
    if(!texture.current || !ref.current) return;

    texture.current.offset.x = clock.getElapsedTime() / 10;
    ref.current.material.opacity -= (clock.elapsedTime - oldTime);

    raycaster.setFromCamera(mouse, camera);

    const intersects = raycaster.intersectObjects([ref.current], false );
    if(intersects.length > 0)
    {
      ref.current.material.opacity = 0.8;
    }

    oldTime = clock.getElapsedTime();
    // console.log(scene.getObjectByName('tracable'));
  })
  return (
      <mesh position={position} ref={ref} renderOrder={1} name={person.address} nextScene={2}>
        <cylinderGeometry args={[5, 5, 2, 64, 1, true]} />
        <meshBasicMaterial transparent attach="material" depthWrite={false}  opacity={0.4}>
          <canvasTexture
            attach="map"
            repeat={[4, 1]}
            image={canvas}
            premultiplyAlpha
            ref={texture}
            wrapS={THREE.RepeatWrapping}
            wrapT={THREE.RepeatWrapping}
            onUpdate={(s) => (s.needsUpdate = true)}
          />
        </meshBasicMaterial>
      </mesh>);
}

function Core({setScene}) {
  const ref = useRef();
  const { scene, camera } = useThree();
  camera.position.set(0, 10, 20);

  useFrame(({clock, raycaster, mouse}) => {
    if(!ref.current) return;

    ref.current.rotation.y = clock.elapsedTime*5;

    raycaster.setFromCamera(mouse, camera);

    if(clicked)
    {
      clicked = false;
      const intersects = raycaster.intersectObjects(scene.getObjectByName('tracable').children, true );
      if(intersects.length > 0)
      {
        // console.log(intersects[0].object.nextScene);
        currentArtist = intersects[0].object.name;
        setScene(intersects[0].object.nextScene);
      }
    }
    
  })

  return (
  <mesh ref={ref} position={[0,-20,0]}>
    <boxGeometry args={[0.3,80,0.3]} />
    <meshBasicMaterial color={'#7777aa'} />
  </mesh>)
}

function Island() {
  const texture2 =  useLoader(THREE.TextureLoader, "mountain2.png");
  const texture = useLoader(THREE.TextureLoader, "mountain.png");


  useFrame(({clock}) => {
    // texture3.repeat.set(Math.sin(clock.elapsedTime) * 3, Math.sin(clock.elapsedTime) * 3);
    // texture2.offset.set(0, 0.5);
  })

  return (
  <>
  <mesh rotation={[Math.PI / 2, 0,0]} position={[0,-1,0]}>
    <ringGeometry args={[0,80,100,100]} />
    <meshStandardMaterial transparent={true} side={THREE.DoubleSide} displacementScale={80}  map={texture2} displacementMap={texture}/>
  </mesh>
  </>);
}

function Road() {
  const circles = [1,2,3,4,5,6,7,8,9,10];

  const texture3 =  useLoader(THREE.TextureLoader, "line.png");
  texture3.wrapT = THREE.RepeatWrapping;
  texture3.wrapS = THREE.RepeatWrapping;
  texture3.repeat.set(20,1)

  useFrame(({clock}) => {
    texture3.offset.set(clock.elapsedTime, 0);
  })

  return (
  <>
  {
    circles.map((i) => (
    <mesh rotation={[Math.PI / 2, 0, 0]} position={[0,-1,0]} name={'circle' + i} key={i}>
      <torusGeometry args={[i*5, 0.3,20,100]} />
      <meshBasicMaterial transparent={true} color={0x6688aa}/>
    </mesh>
    ))
  }
  {
    circles.map((i) => i < 6 ? (
    <mesh rotation={[Math.PI / 2, 0, 0]} position={[0,-1,0]} renderOrder={1} name={'circle2' + i} key={i}>
      <torusGeometry args={[i * 10 - 2.5, 0.3,20,100]} />
      <meshBasicMaterial transparent={true} color={0x6688aa} map={texture3}/>
    </mesh>
    ) : null)
  }
  </>);
}

function Name({person, radius, i}) {
  const ref = useRef()
  const { scene } = useThree();

  useEffect(() => {
    let tracable = scene.getObjectByName('tracable');
    if(!tracable.getObjectByName(person.address))
    {
      const start = new THREE.Vector3(Math.cos(Math.PI * 2 / 10 * i) * radius, 0, Math.sin(Math.PI * 2 / 10 * i) * radius);
      const tempObj = new THREE.Mesh(new THREE.BoxGeometry(4,12,4), new THREE.MeshBasicMaterial({visible: false}));
      tempObj.position.copy(start);
      tempObj.name = person.address;
      tempObj.nextScene=3;
      tracable.add(tempObj);
    }
  })
  // console.log(tracable);

  return (<Html ref={ref} position={[Math.cos(Math.PI * 2 / 10 * i) * radius, 7, Math.sin(Math.PI * 2 / 10 * i) * radius]} style={{ pointerEvents: "none"}}>
            <div style={{color: 'white', transform: 'translate(-50%, 0)'}} className='clickThrough'>{person.name}</div>
          </Html>);
}

function Bloom({ children }) {
  const { gl, camera, size } = useThree()
  const [scene, setScene] = useState()
  const composer = useRef()
  useEffect(() => void scene && composer.current.setSize(size.width, size.height), [size])
  useFrame(() => scene && composer.current.render(), 1)
  return (
    <>
      <scene ref={setScene}>{children}</scene>
      <effectComposer ref={composer} args={[gl]}>
        <renderPass attachArray="passes" scene={scene} camera={camera} />
        <unrealBloomPass attachArray="passes" args={[undefined, 2, 0.5, 0]} />
      </effectComposer>
    </>
  )
}

function Main({ children }) {
  const scene = useRef()
  const { gl, camera } = useThree()
  useFrame(() => {
    gl.autoClear = false
    gl.clearDepth()
    gl.render(scene.current, camera)
  }, 2)
  return <scene ref={scene}>{children}</scene>
}

function Background({...args}) {
  const ref = useRef();
  const texture = useLoader(THREE.TextureLoader, "grid.png");
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(1,20);


  useFrame(({clock, camera}) => {
    texture.offset.set(0, clock.elapsedTime);
    let pos = camera.position.clone();
    pos.y = 0;
    ref.current.position.copy(new THREE.Vector3(args.position[0], args.position[1], args.position[2]));

    while(camera.position.x > ref.current.position.x + 50) ref.current.position.x += 100;
    while(camera.position.z > ref.current.position.z + 50) ref.current.position.z += 100;
    while(camera.position.x < ref.current.position.x - 50) ref.current.position.x -= 100;
    while(camera.position.z < ref.current.position.z - 50) ref.current.position.z -= 100;
  })

  return (
  <group ref={ref} {...args}>
    <mesh rotation={[Math.PI, 0, 0]}>
      <boxGeometry args={[8,200,8]} />
      <meshBasicMaterial map={texture} side={THREE.DoubleSide} transparent={true} opacity={0.5}/>
    </mesh>
    <mesh>
      <boxGeometry args={[10,200,10]}  />
      <meshBasicMaterial map={texture} side={THREE.DoubleSide} transparent={true}/>
    </mesh>
  </group>
  );
}

function Glitch({...args}) {
  const texture = useLoader(THREE.TextureLoader, "grid2.png");
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(1,0.001);


  useFrame(({clock, camera}) => {
    texture.offset.set(0, clock.elapsedTime/2);
  })

  return (
    <group {...args}>
    <mesh>
      <planeGeometry args={[20,20]} />
      <meshBasicMaterial map={texture} side={THREE.DoubleSide} transparent={true} opacity={0.5}/>
    </mesh>
  </group>
  );
}

function LightFollow() {
  const ref = useRef();
  const {camera} = useThree();

  useFrame(() => {
    ref.current.position.copy(camera.position);
    ref.current.position.y = 0;
  })

  return (<pointLight ref={ref} intensity={1} color={0x66aaff}/>);
}

function Dolly() {
  let {camera} = useThree();
  useEffect(() => {
    camera.far = 150;
    camera.updateProjectionMatrix();
  })

  return null;
}

let startTime, startPos, firstTime = true, btn = false;
function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);
  const [creations, setArt] = useState([]);
  const [scene, setScene] = useState(1);
  const floors = [0,1,2,3,4,5,6,7,8,9,10];
  const [collectionOrArt, setCol] = useState(true);

  useEffect(() => {
    if(scene === 1 && firstTime) {
      Promise.all([doFetch(objkt), doFetch(objktPart2)])
      .then((values) => {
        console.log(values);
        let data1 = changeData(values[0]);
        let data2 = changeData(values[1]);
        return [data1, data2];
      })
      .then((char) => {set(char); firstTime = false;})
    }
    else if(scene === 2 || scene === 3) {
      
      doFetchArtist(currentArtist)
      .then((art) => {
        if(art.length > 0 && collectionOrArt) setArt(art);
        else doFetchCollector(currentArtist)
             .then((art) => setArt(art));
      });
    }
    
    // doFetch(objkt)
    //   .then((data) => changeData(data))
    //   .then((char) => set(char));
    // doFetch(objktPart2)
    //   .then((data) => changeData(data))
    //   .then((char) => set(char));
  }, [scene, collectionOrArt])


  return (
    <div id="wrapper" onMouseDown={(e) => {startTime = new Date(); startPos = {x: e.clientX, y: e.clientY};}} onMouseUp={(e) => {
      if(new Date() - startTime < 250 && Math.pow((e.clientX - startPos.x),2) + Math.pow((e.clientY - startPos.y),2) < 50 && scene == 1) {
        console.log("CLICKED");
        clicked = true;
      }
    }}>
  <Canvas onCreated={state => state.gl.setClearColor("black")} viewport>
    <group name='tracable'><group name='tracableInner'></group></group>
    
    <ambientLight intensity = {0.1} />
    <pointLight position={[0,-60,0]} intensity={1.0} color={'white'} distance={50}/>
    <pointLight position={[0,10,0]} intensity={0.5} color={'white'} distance={35}/>
    <Suspense fallback={null}>
      {{
      '1': (<group name={'scene1'}>
      <Effect intensity={2}/>
      <OrbitControls target={new THREE.Vector3(0,10,0)}/> 
        <Particles count={300}/>
        <Core setScene={setScene}/>
        <Island />
        <Road />
        <Houses count={200} radius={22.5} amount={10}/>
        <Houses count={200} radius={32.5} amount={10}/>
        {
          characters[1]?.map((person, i) => { return i < 10 ? <Name person={person} i={i} radius={22.5}/>: 
                                                            <Name person={person} i={i} radius={32.5}/> })
        }
        {floors.map((i) =>
          <>
          <mesh rotation={[-Math.PI / 2,0,0]} position={[0,-0.5 + i*2,0]}>
            <circleGeometry args={[4,32]} />
            <meshBasicMaterial color={0x4466aa} transparent={true} opacity={0.5} />
          </mesh>
          <Bilboard person={characters[0] && characters[0][i] ? characters[0][i] : {name: ' ', address: ''}} position={[0, 0.5 + i*2,0]}/>
          </>
          )
        }
      </group>),

      '2':(
        <>
        {/* <Effect intensity={0.2}/> */}
        <FirstPersonControls lookSpeed={0.1} movementSpeed={10} dragToLook={true}/>
        <Bloom>
          <pointLight position={[0,0,0]} intensity={0.2} color={'white'} />
          <mesh rotation={[-Math.PI / 2,0,0]} position={[0,-2,0]}>
            <circleGeometry args={[20,32]} />
            <meshBasicMaterial color={0x224466} />
          </mesh>
          <mesh rotation={[Math.PI / 2,0,0]} position={[0,18,0]}>
            <circleGeometry args={[20,32]} />
            <meshBasicMaterial color={0x224466} />
          </mesh>
          <Skyscraper count={200} />
        </Bloom>
        <Main>
        <group name={'tracable2'} >
        {
          creations.map((uri, i) => 
            i <= 50 ? <Preload uri={uri} position={[Math.sin(i * 2 * Math.PI * 2 / 20) * 13,Math.floor(i/10) * 4,Math.cos(i * 2 * Math.PI * 2 / 20) * 13]} rotation={[0, Math.PI + i * Math.PI * 2 * 2 / 20,0]} name={uri} index={i} key={i}/> : null
          )
        }
        </group>
        </Main>
        
        <Html transform pointerEvents={'none'} name={'image'}>
          <img loading="lazy" decoding="async" alt="loading" width={120} height={120} id={'image'} />
        </Html>

        <Html>
          <button className='btnContainer' onClick={() => {setScene(1); setCol(true);}}>Back</button>
          <button className='btnContainer' onClick={() => {setCol(false)}}>Collection</button>
        </Html>
        </>
      ),

      '3':(
        <>
        <Dolly />
          <FirstPersonControls lookSpeed={0.1} movementSpeed={10} dragToLook={true} />
          <Bloom>
            <LightFollow />
            <mesh rotation={[-Math.PI / 2, 0, 0]} renderOrder={2}>
              <planeGeometry args={[1000,1000]} />
              <meshBasicMaterial color={0x224466} transparent={true} opacity={0.1} side={THREE.DoubleSide}/>
            </mesh>
            <Floor count={300} />
            <Background position={[-25,99,-25]}/>
            <Background position={[-25,-99,-25]} rotation={[Math.PI, 0, 0]}/>
            <Background position={[25,99,-25]}/>
            <Background position={[25,-99,-25]} rotation={[Math.PI, 0, 0]}/>
            <Background position={[-25,99,25]}/>
            <Background position={[-25,-99,25]} rotation={[Math.PI, 0, 0]}/>
            <Background position={[25,99,25]}/>
            <Background position={[25,-99,25]} rotation={[Math.PI, 0, 0]}/>
            {
              creations.map((uri, i) => 
                i <= 50 ? <>
                  <Glitch position={[0,20,-i*50]}/>
                  <Glitch position={[0,-20,-i*50]}/>
                </> : null
              )
            }
            
            {/* <mesh>
              <boxGeometry args={[100,0.1,100]} />
              <meshPhysicalMaterial color={0x555555} roughness={0.3} metalness={0.7} />
            </mesh> */}
          </Bloom>
          <Main>
            <group name={'tracable2'} >
            {
              creations.map((uri, i) => 
                i <= 50 ? <Preload uri={uri} position={[0,20,-i * 50]} scale={[5,5,5]} name={uri} index={i} key={i}/> : null
              )
            }
            </group>
            
            <Html transform pointerEvents={'none'} name={'image'} scale={[5,5,5]} position={[0,20,0]}>
              <img loading="lazy" decoding="async" alt="loading" width={120} height={120} id={'image'} />
            </Html>
            <Html>
              <button className='btnContainer'  onClick={() => {setScene(1); setCol(true);}}>Back</button>
              <button className='btnContainer'  onClick={() => {setCol(false);}}>Collection</button>
            </Html>
          </Main>
        </>
      )
      }[scene]
      }
    </Suspense>

    {/* <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
